import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useTitle } from "../hooks/useTitle";
import { Form, Spin } from "antd";
import Title from "antd/es/typography/Title";
import { Content } from "antd/es/layout/layout";
import { useParams } from "react-router-dom";
import { useGetAcceptInviteInfo } from "../queries/user";
import { InviteErrorResult } from "../components/InviteErrorResult";
import { AxiosError } from "axios";
import { AcceptInviteForm } from "../components/AcceptInviteForm";

const AcceptInvitePage = () => {
  const { t } = useTranslation();
  useTitle(t("page-title.accept-invite"));
  const [form] = Form.useForm();
  const { "invite-token": inviteToken } = useParams<{
    "invite-token": string;
  }>();
  const {
    data: inviteInfo,
    isError,
    isFetching,
    isSuccess,
  } = useGetAcceptInviteInfo(inviteToken, (_failureCount, error: Error) => {
    const axiosError = error as AxiosError<AxiosError>;
    return axiosError.response?.data.message != "Invite token not found";
  });

  useEffect(() => {
    if (isSuccess && inviteInfo) {
      form.setFieldsValue({ email: inviteInfo.email });
    }
  }, [inviteInfo, isSuccess]);

  if (isError) return <InviteErrorResult />;

  if (isFetching || !inviteInfo) return <Spin />;

  return (
    <>
      <Content
        style={{
          display: "flex",
          flexDirection: "column",
          textAlign: "center",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "#FFFFFF",
        }}
      >
        <Title level={2}>{t("MeetingSpace")}</Title>
        <div
          style={{
            width: "100%",
            maxWidth: 500,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "flex-start",
            marginTop: "1.5rem",
          }}
        >
          <AcceptInviteForm
            form={form}
            inviteInfo={inviteInfo}
            inviteToken={inviteToken}
          />
        </div>
      </Content>
    </>
  );
};

export default AcceptInvitePage;
